// extracted by mini-css-extract-plugin
export default {"container":"sidebar_container__I9auK","center":"sidebar_center__DfyIy","verticalContainer":"sidebar_verticalContainer__6g-fg","item":"sidebar_item__AWpDX"};